import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components6';
import { IconOption } from 'rwl-shared/dist/models/widget';
import { ContentSource } from 'rwl-shared/dist/models/ContentSource';
import { getIcon, getIconColor } from '../../../../utils';
import { When } from 'react-if';
import { ReviewBadge } from '../../../../components/ReviewBadge';

type JobMarkerContentProps = {
    icon: IconOption;
    iconTint: string;
    isSelected?: boolean;
    isPopupOpen?: boolean;
    hasReview?: boolean;
    reviewSource?: ContentSource;
};

const MarkerContainer = styled.div.withConfig({
    shouldForwardProp: (prop) =>
        !['colors', 'isSelected', 'iconTint', 'isPopupOpen', 'icon'].includes(
            prop
        ),
})<{
    colors: { fill: string; backDrop: string };
    isSelected?: boolean;
    isPopupOpen?: boolean;
    iconTint?: string;
    icon?: IconOption;
}>`
    display: inline-flex;
    border: ${({ isSelected, iconTint }) =>
        isSelected ? `2px solid ${iconTint}` : 'none'};
    border-radius: 50%;
    transition: all 0.2s ease;

    ${({ isPopupOpen, colors, icon }) =>
        isPopupOpen && icon !== IconOption.House
            ? `
        background: ${colors.fill};
        svg {
            background: ${colors.fill};
            color: ${colors.backDrop};
        }
    `
            : ''}

    :hover {
        ${({ colors, icon }) =>
            icon !== IconOption.House
                ? `
            background: ${colors.fill};
            svg {
                background: ${colors.fill};
                color: ${colors.backDrop};
            }
        `
                : ''}
    }
`;

const IconContainer = styled.div.withConfig({
    shouldForwardProp: (prop) => !['colors'].includes(prop),
})<{ colors: { fill: string; backDrop: string } }>`
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${({ colors }) => colors.backDrop};
    border-radius: 50%;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
    height: 20px;
    width: 20px;
`;

const MarkerWrapper = styled.div`
    position: relative;
`;

const BadgeWrapper = styled.div.withConfig({
    shouldForwardProp: (prop) => !['reviewSource'].includes(prop),
})<{ reviewSource?: ContentSource }>`
    position: absolute;
    top: -8px;
    right: ${({ reviewSource }) =>
        reviewSource === ContentSource.GMB ||
        reviewSource === ContentSource.Facebook
            ? '-18px' // Wide badge with icon + star
            : '-8px'}; // Narrow badge with just star
    z-index: 10;
`;

const JobMarkerContent = ({
    icon,
    iconTint,
    isSelected,
    isPopupOpen,
    hasReview,
    reviewSource,
}: JobMarkerContentProps) => (
    <MarkerWrapper>
        <MarkerContainer
            colors={getIconColor(icon, iconTint)}
            isSelected={isSelected}
            isPopupOpen={isPopupOpen}
            iconTint={iconTint}
            icon={icon}
        >
            <IconContainer
                className="jobMarker"
                colors={getIconColor(icon, iconTint)}
            >
                <FontAwesomeIcon
                    icon={getIcon(icon)}
                    color={getIconColor(icon, iconTint).fill}
                    size="1x"
                />
            </IconContainer>
        </MarkerContainer>

        <When condition={hasReview}>
            <BadgeWrapper reviewSource={reviewSource}>
                <ReviewBadge reviewSource={reviewSource} />
            </BadgeWrapper>
        </When>
    </MarkerWrapper>
);

export default JobMarkerContent;
